import { Button } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import Icon from '@/components/Icon'
import { ModalBase } from '@/components/Modal/ModalBase'
import { useModal } from '@/context/ModalContext'
import { GTMEventCategory } from '@/utils/tracking/eventCategory'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { ModalTypeForm } from './ModalTypeForm'
import { modalTypeForm } from './styles.css'

export const ButtonFeedback = ({ ...props }) => {
  const { t } = useTranslation()
  const { openModal } = useModal()
  const handleFeedbackCta = () => {
    handleClick(GTMEventCategory.PriorityDetail, 'FloatingBanner_Dislike')
    openModal(
      <ModalBase className={modalTypeForm}>
        <ModalTypeForm />
      </ModalBase>,
      { overlay: true }
    )
  }

  return (
    <Button
      Icon={() => <Icon.ThumbDownAlt />}
      label={t('priority:PriorityDetail-FloatingBanner-DislikeCTA')}
      styleVariant="tertiary"
      onClick={handleFeedbackCta}
      {...props}
    />
  )
}
